





















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import GalaPowerBar from '~/components/GalaPower/GalaPowerBar.vue';
import { IWallet } from '~/store/inventory/types';

@Component({
  components: {
    GalaPowerBar,
  },
})
export default class GalaPowerLevelUp extends Vue {
  @State(profile => profile.user.loggedIn, { namespace: 'profile' })
  loggedIn!: boolean;
  @State(inventory => inventory.wallets, { namespace: 'inventory' })
  wallets!: IWallet[];

  @Action('fetchGalaPower', { namespace: 'profile' })
  private fetchGalaPower!: () => void;

  previousPowerLevel = 0;
  currentPowerLevel = 0;
  powerBarPercent = 0;
  modalControl = false;
  levelsFetchCompleted = false;
  isVideoActive = false;
  isVideoComplete = false;

  get showModal() {
    return (
      this.loggedIn &&
      this.modalControl &&
      this.levelsFetchCompleted &&
      this.currentPowerLevel > this.previousPowerLevel
    );
  }

  get currentLevelDisplay() {
    const levelDisplayNumber = this.currentPowerLevel.toString().split('');
    while (levelDisplayNumber.length < 3) {
      levelDisplayNumber.unshift('0');
    }

    return levelDisplayNumber.join('');
  }

  get previousLevelDisplay() {
    const levelDisplayNumber = this.previousPowerLevel.toString().split('');
    while (levelDisplayNumber.length < 3) {
      levelDisplayNumber.unshift('0');
    }

    return levelDisplayNumber.join('');
  }

  get isSafari() {
    return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  }

  triggerTextAnimation() {
    this.isVideoActive = true;
    this.isVideoComplete = false;
  }

  onVideoEnd() {
    this.isVideoComplete = true;
  }

  getLocalGalaPowerLevel() {
    const localPower = localStorage.getItem('galaPowerLevel') || '0';
    this.previousPowerLevel = parseInt(localPower);
  }

  async getGalaPower() {
    const galaPower: any = await this.fetchGalaPower();

    if (galaPower && !this.modalControl) {
      this.currentPowerLevel = Math.floor(galaPower);
      this.getLocalGalaPowerLevel();
      localStorage.setItem('galaPowerLevel', this.currentPowerLevel.toString());
      this.levelsFetchCompleted = true;
      if (this.currentPowerLevel > this.previousPowerLevel) {
        this.modalControl = true;
      }
      setTimeout(() => {
        this.powerBarPercent = 100;
      }, 1000);
    }
  }

  updateGalaPower() {
    if (!this.modalControl && this.loggedIn) {
      this.levelsFetchCompleted = false;
      this.previousPowerLevel = 0;
      this.currentPowerLevel = 0;
      this.powerBarPercent = 0;
      this.getGalaPower();
    }
  }

  @Watch('loggedIn')
  updateLoggedIn() {
    this.updateGalaPower();
  }

  @Watch('wallets')
  onWalletsUpdated() {
    setTimeout(() => {
      this.updateGalaPower();
    }, 1000);
  }
}
